import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import Sections from '~/constants/sections';
import UpArrow from '~/icons/UpArrow';
import { getHasOwnerReviews, getShouldShowPriceDetails } from '~/selectors';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import {
  DesktopPageNavigationWrapper,
  DesktopStickyPageNavigationInnerWrapper,
  DesktopStickyPageNavigationWrapper,
  NavigationButton,
  NavigationColumnOne,
  NavigationColumnTwo,
  NavigationTab,
  NavigationTabIndicator,
  NavigationText
} from './DesktopPageNavigation.styles';
import { useCurrentSection, useSticky } from './hooks';

const topOffset = 137; // It's maaaaagiiiic....

const DesktopPageNavigation = () => {
  const currentSection = useCurrentSection(topOffset);
  const shouldShowPriceDetails = useSelector(getShouldShowPriceDetails);
  const hasOwnerReviews = useSelector(getHasOwnerReviews);
  const { isSticky, updateStickyState } = useSticky();
  const analyticsId = isSticky ? 'Sticky Header' : 'Navbar';

  return (
    <>
      <DesktopPageNavigationWrapper>
        <Waypoint
          topOffset={78}
          onEnter={updateStickyState}
          onLeave={updateStickyState}
        />
      </DesktopPageNavigationWrapper>
      <DesktopStickyPageNavigationWrapper
        data-qa="desktop-sticky-page-navigation-wrapper"
        id="desktop-navigation"
      >
        <DesktopStickyPageNavigationInnerWrapper
          className={classnames({ 'box-shadow': isSticky })}
        >
          <NavigationColumnOne>
            {isSticky && (
              <NavigationButton
                href={`#${Sections.Root}`}
                data-analytics-id="Nav - Top"
              >
                <UpArrow />
                <NavigationText className="mx-8">Top</NavigationText>
              </NavigationButton>
            )}
          </NavigationColumnOne>
          <NavigationColumnTwo>
            <NavigationTab
              href={`#${Sections.KeyFeatures}`}
              data-analytics-id={analyticsId}
              data-analytics-attributes={JSON.stringify({
                label: 'Key Features'
              })}
            >
              <NavigationText>Key Features</NavigationText>
              {currentSection === Sections.KeyFeatures && (
                <NavigationTabIndicator />
              )}
            </NavigationTab>
            <NavigationTab
              href={`#${Sections.VehicleDetails}`}
              data-analytics-id={analyticsId}
              data-analytics-attributes={JSON.stringify({
                label: 'Vehicle Details'
              })}
            >
              <NavigationText>Vehicle Details</NavigationText>
              {currentSection === Sections.VehicleDetails && (
                <NavigationTabIndicator />
              )}
            </NavigationTab>
            {shouldShowPriceDetails && (
              <NavigationTab
                href={`#${Sections.PriceDetails}`}
                data-analytics-id={analyticsId}
                data-analytics-attributes={JSON.stringify({
                  label: 'Price Details'
                })}
              >
                <NavigationText>Price Details</NavigationText>
                {currentSection === Sections.PriceDetails && (
                  <NavigationTabIndicator />
                )}
              </NavigationTab>
            )}
            {hasOwnerReviews && (
              <NavigationTab
                href={`#${Sections.OwnerReviews}`}
                data-analytics-id={analyticsId}
                data-analytics-attributes={JSON.stringify({
                  label: 'Owner Reviews'
                })}
              >
                <NavigationText>Owner Reviews</NavigationText>
                {currentSection === Sections.OwnerReviews && (
                  <NavigationTabIndicator />
                )}
              </NavigationTab>
            )}
            <NavigationTab
              href={`#${Sections.Inspection150Point}`}
              data-analytics-id={analyticsId}
              data-analytics-attributes={JSON.stringify({
                label: 'Inspection'
              })}
            >
              <NavigationText>Inspection</NavigationText>
              {currentSection === Sections.Inspection150Point && (
                <NavigationTabIndicator />
              )}
            </NavigationTab>
          </NavigationColumnTwo>
        </DesktopStickyPageNavigationInnerWrapper>
      </DesktopStickyPageNavigationWrapper>
    </>
  );
};

export default withErrorBoundary(DesktopPageNavigation);
